import { render } from "./flats-crm-section.vue?vue&type=template&id=4aa0ba0e"
import script from "./flats-crm-section.vue?vue&type=script&lang=js"
export * from "./flats-crm-section.vue?vue&type=script&lang=js"

import "./flats-crm-section.vue?vue&type=style&index=0&id=4aa0ba0e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__